module.exports = __webpack_public_path__ + "static/media/flamingos.ba6b0da7.jpg";